import { styled } from '@mui/system';
import TableCell from '@mui/material/TableCell';

export const Root = styled('div')(
    `
    table {
      font-family: 'IBM Plex Sans', sans-serif;
      font-size: 0.875rem;
      border-collapse: collapse;
      width: 100%;
    }
  
    td,
    th {
      border: 1px solid $#303740;
      text-align: left;
      padding: 8px;
    }
  
    th {
      background-color: '#fff'};
    }
    `,
  );

  export const BaseCell = styled(TableCell)(() => (
    {
      padding: '5px', 
      fontSize: '12px',
    }));
    export const HeaderCell = styled(BaseCell)(() => (
      {
        fontWeight: 'bold', 
      }));